import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import AlternativeCard from './components/AlternativeCard';
import { getWinners } from './helpers';

import classes from './Alternatives.module.scss';

const MAX_ALTERNATIVES = 3;

const SWIPER_BREAKPOINTS_CONFIG = {
  360: {
    slidesPerView: 1.2,
    centeredSlides: false,
    spaceBetween: 14,
  },
  600: {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 14,
  },
  960: {
    slidesPerView: 2.4,
    centeredSlides: false,
    spaceBetween: 14,
  },
  1280: {
    slidesPerView: 4,
    centeredSlides: false,
    spaceBetween: 14,
  },
};

const Alternatives = ({ listing, showPplPricingBanner }) => {
  const alternatives = [
    listing,
    ...listing.alternatives_comparisons.slice(0, MAX_ALTERNATIVES),
  ];
  const ratingWinners = getWinners(alternatives);
  return (
    <div className={classes.root}>
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true, el: '#cr-alternatives-pagination' }}
        breakpoints={SWIPER_BREAKPOINTS_CONFIG}
        simulateTouch={false}
      >
        {alternatives.map((alternative, index) => (
          <SwiperSlide key={index}>
            <AlternativeCard
              listing={alternative}
              ratingWinners={ratingWinners}
              isMain={index === 0}
              listingPosition={index}
              showPplPricingBanner={showPplPricingBanner}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div id="cr-alternatives-pagination" className={classes.pagination} />
    </div>
  );
};

export default Alternatives;
